import { FormAddSales } from "../../components";

export const AddSales = () => {
  return (
    <div className="container__pages">
      <h2>Registar Venta</h2>
      <div className="container_form">
        <FormAddSales />
      </div>
    </div>
  );
};
